import { calculateAmortizationWithMarketRequirements } from "../amortization/amortization";
import { calculateConstantAmortization, AmortizationType } from "../../../amortization";
import { calculateTotalMonthlyInterestExpense } from "../../../interest";
import { deepClone } from "../../../utils";
/**
 * Calculates the mortgage loan amounts, amortization amounts and total amount,
 * amortization rates, interest amounts and total amount.
 *
 * @param input Forecast input for swedish market
 * @param month Current forecast year
 * @param amortizationRequirementHistory Relevant amortization rate history, loan amount at rate change and highest household salary income so far
 * @param localizationParameters Swedish mortgage market regulated parameters
 * @returns Mortgage expenses and amortization rates
 */
export function calculateMortgageExpenses(input, amortizationHistory, localizationParameters) {
    var _a, _b;
    if (input.mortgage.length === 0) {
        return {
            monthlyAmortization: [],
            loanToValueAmortizationRate: 0,
            debtToIncomeAmortizationRate: 0,
            totalMonthlyAmortization: 0,
            totalMonthlyInterestBeforeDeduction: 0,
        };
    }
    const inputClone = deepClone(input);
    let amortizationResult;
    if (input.amortizationType === AmortizationType.MARKET_SPECIFIC) {
        amortizationResult = calculateAmortizationWithMarketRequirements(inputClone.housingValue, inputClone.mortgage, amortizationHistory, localizationParameters, (_a = inputClone.additionalHousing) === null || _a === void 0 ? void 0 : _a.mortgage, inputClone.customLoanToValueAmortizationRate);
    }
    else {
        amortizationResult = Object.assign(Object.assign({}, calculateConstantAmortization(inputClone.mortgage)), { loanToValueAmortizationRate: 0, debtToIncomeAmortizationRate: 0 });
    }
    const totalMonthlyInterestBeforeDeduction = calculateTotalMonthlyInterestExpense(input.mortgage);
    let additionalMortgageAmortization;
    let additionalMortgageInterest;
    if ((_b = input.additionalHousing) === null || _b === void 0 ? void 0 : _b.mortgage) {
        additionalMortgageAmortization = calculateConstantAmortization(input.additionalHousing.mortgage).totalMonthlyAmortization;
        additionalMortgageInterest = Math.round(calculateTotalMonthlyInterestExpense(input.additionalHousing.mortgage));
    }
    return Object.assign(Object.assign({}, amortizationResult), { totalMonthlyInterestBeforeDeduction,
        additionalMortgageAmortization,
        additionalMortgageInterest });
}
